var e = /* @__PURE__ */ ((r) => (r.RIGHT = "right", r.LEFT = "left", r.NONE = "none", r))(e || {});
export {
  e as I
};
